import Star from "./svg/Star";

function GoogleStars({ rating, showLabel = false }) {
  const totalStars = 5;
  return (
    <div className="flex items-center gap-2">
      {showLabel && (
        <span className="text-base text-gray-400">
          Celkové hodnocení {rating}
        </span>
      )}
      <span className="inline-flex">
        {[...Array(totalStars)].map((_, i) => (
          <Star
            key={i}
            w={24}
            h={24}
            className={i < rating ? "text-gold" : "text-gray-400 opacity-40"}
          />
        ))}
      </span>
    </div>
  );
}

export default GoogleStars;
